/**
 * Downloads are not currently available on the web.
 */
export default function DownloadButton(): null {
  return null
}
